import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table, Form, Image, Card } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { ToWords } from "to-words";
import moment from "moment";
import {
  getSubscriptionVoucher,
  selectSubscriptionVoucherById,
} from "../../store/getAllSubscriptionVoucherSlice";
import QRCode from "react-qr-code";
import "../../../shared/components/invoice.css";
import { calculateTotalQuantity } from "../../components/helpers/cartHelper";
import { regionCode } from "../../../States";
import billplus from "../../../assets/images/billplusLogo.png";
import { formatAmount } from "../../components/helpers/cartHelper";
import GlobalCurrency from "../../../shared/components/GlobalCurrency";

const DonationSubscriptionAllInvoiceDefault = ({ pdf, id, data }) => {
  const dispatch = useDispatch();

  const selectedBusiness = useSelector(
    (state) => state?.auth?.selectedBusiness
  );

  const accessToken = useSelector((state) => state?.auth?.token);

  const tenantId = useSelector((state) => state?.auth?.tenantId);
  const [packageName, setPackageName] = useState("");
  const subData = useSelector(
    (state) => state.subscriptionVoucher.subscriptionVoucherById
  );
  const [subsData, setSubsData] = useState(subData);

  const subscriptionTotal =
    subsData?.donation_voucher_subscription?.donation_subscription;

  useEffect(() => {
    if (data) {
      setSubsData(data);
      if (data.length > 0) {
        setPackageName(
          data[0]?.donation_voucher_subscription?.donation_subscription
            ?.donation_package?.name
        );
      }
    }
  }, [data]);

  useEffect(
    () => {
      dispatch(
        getSubscriptionVoucher({
          id: id,
          tenantId: tenantId,
          token: accessToken,
        })
      );
    },
    { id }
  );

  const grandTotal = formatAmount(subsData?.grand_total) ?? 0;
  const paidAmount = formatAmount(subsData?.paid_amount) ?? 0;
  const balanceAmount = formatAmount(grandTotal - paidAmount);
  const words = new ToWords().convert(grandTotal, { currency: true });
  const totalQuantity = calculateTotalQuantity(
    subsData?.donation_voucher_items
  );

  const termsAndCondition = useSelector(
    (state) => state.setting?.billing_settings?.terms_and_conditions
  );
  const fetchData = useSelector((state) => state.getSetting?.dataSetting);
  const customerState = regionCode.find(
    (option) => option.id == subsData?.party?.party_addresses?.[0]?.state
  );
  const state = regionCode.find((option) => option.id == fetchData?.state);

  const bankDetailsCheck =
    fetchData?.card_holder_name ||
    fetchData?.account_number ||
    fetchData?.ifsc_code ||
    fetchData?.bank ||
    fetchData?.branch_name;

  const generateQRCode = (UPIPayment) => {
    const upiLink = `upi://pay?pa=${UPIPayment}`;
    return (
      <QRCode
        value={upiLink}
        size={90}
        bgColor={"#ffffff"}
        fgColor={"#000000"}
        level={"L"}
      />
    );
  };
  return (
    <>
      <Container
        fluid
        className="pb-5"
        ref={pdf}
        style={{ backgroundColor: "white" }}
      >
        <Row>
          <Col className=" p-2 m-0">
            <p style={{ fontWeight: "bolder" }}>
              {"TAX INVOICE"}
              <span
                className="border border-secondary px-2 mx-2"
                style={{ fontWeight: 500 }}
              >
                {"ORIGINAL FOR RECIPIENT"}
              </span>
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <img
              src={fetchData?.logo}
              width={120}
              height={80}
              alt="Logo"
              style={{
                objectFit: "contain",
              }}
            />
          </Col>
          <Col lg={9}>
            <Row className="mt-5">
              <Row>
                <Col>
                  <Form.Label
                    className=""
                    style={{ fontSize: "28px", fontWeight: 600 }}
                  >
                    {fetchData?.business_name}
                  </Form.Label>
                  <Form.Group>
                    <Form.Label className="mb-0">
                      {fetchData?.business_address
                        ? fetchData?.business_address + ","
                        : ""}
                      &nbsp; {fetchData?.city ? fetchData?.city + "," : ""}
                      &nbsp; {state?.label ? state?.label + "-" : ""}
                      &nbsp;&nbsp; {fetchData?.pincode}
                    </Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                {fetchData?.business_phone && (
                  <Col lg={4}>
                    <Form.Label style={{ fontWeight: 600 }} className="mb-0">
                      {"Phone"} :{" "}
                    </Form.Label>{" "}
                    &nbsp;{" "}
                    <Form.Label>
                      {" "}
                      {fetchData?.business_phone
                        ? fetchData?.business_phone
                        : ""}
                    </Form.Label>
                  </Col>
                )}
                {fetchData?.gstin && (
                  <Col lg={4}>
                    <Form.Label className="mb-0" style={{ fontWeight: 600 }}>
                      {"GSTIN"} :
                    </Form.Label>{" "}
                    <Form.Label>
                      {" "}
                      &nbsp; {fetchData?.gstin ? fetchData?.gstin : ""}
                    </Form.Label>
                  </Col>
                )}
                {fetchData?.pan && (
                  <Col lg={4}>
                    <Form.Label className="mb-0" style={{ fontWeight: 600 }}>
                      {"PAN"} :{" "}
                    </Form.Label>{" "}
                    &nbsp; {fetchData?.pan ? fetchData?.pan : ""}
                  </Col>
                )}
              </Row>
            </Row>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <Row>
              <Col
                style={{
                  height: "6px",
                  width: "100%",
                  backgroundColor: "black",
                }}
              ></Col>
            </Row>
            <Row
              style={{
                height: "40px",
                backgroundColor: "#E2E2E2",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "14px",
              }}
            >
              <Col>
                <b>{"Invoice No"} :</b> {subsData?.donation_voucher_number}
              </Col>
              <Col>
                <b>{"Invoice Date"} :</b>{" "}
                {moment(
                  subsData?.donation_voucher_subscription?.donation_subscription
                    ?.start_date
                ).format("DD-MM-YYYY")}
              </Col>
              <Col>
                <b>{"Subscription No"} :</b>{" "}
                {
                  subsData?.donation_voucher_subscription?.donation_subscription
                    ?.donation_subscription_number
                }
              </Col>

              {/* {subsData?.due_date && (
                    <Col>
                      <b>{"Due Date"} :</b>{" "}
                      {moment(subsData?.due_date).format("DD-MM-YYYY")}
                    </Col>
                  )} */}
            </Row>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col md={6} py={2} className="px-0 py-3">
            <Row>
              <Col
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "5px",
                }}
              >
                {"BILL TO"}
              </Col>
            </Row>
            <Row>
              <Col style={{ fontWeight: "600", fontSize: "14px" }}>
                {subsData?.party?.name ? subsData?.party?.name : "-"}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.party_addresses?.[0]?.address && (
                  <Form.Group>
                    <Form.Label className="mb-0">
                      {subsData?.party?.party_addresses?.[0]?.address}, &nbsp;{" "}
                      {subsData?.party?.party_addresses?.[0]?.city}, &nbsp;{" "}
                      {customerState?.label} &nbsp;- &nbsp;{" "}
                      {subsData?.party?.party_addresses?.[0]?.pincode}
                    </Form.Label>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.phone_number && (
                  <Form.Group>
                    <Form.Label className="mb-0">{"Phone"} :</Form.Label>
                    &nbsp; {subsData?.party?.phone_number}
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.gstin && (
                  <Form.Group className="">
                    <Form.Label className="mb-0">{"GSTIN"} :</Form.Label>
                    &nbsp; {subsData?.party?.gstin}
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.pan && (
                  <Form.Group>
                    <Form.Label className="mb-0">{"PAN Number"} :</Form.Label>
                    &nbsp; {subsData?.party?.pan}
                  </Form.Group>
                )}
              </Col>
            </Row>
          </Col>
          <Col
            md={subsData?.voucher_subscription?.subscription?.member ? 5 : 6}
            py={2}
            className="px-0 py-3"
          >
            <Col
              style={{
                fontSize: "13px",
                fontWeight: "500",
                marginBottom: "5px",
              }}
            >
              {"SHIP TO"}
            </Col>
            <Row>
              <Col style={{ fontWeight: "600", fontSize: "14px" }}>
                {subsData?.party?.name ? subsData?.party?.name : "-"}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.party_addresses?.[0]?.address && (
                  <Form.Group>
                    <Form.Label className="mb-0">
                      {subsData?.party?.party_addresses?.[0]?.address}, &nbsp;{" "}
                      {subsData?.party?.party_addresses?.[0]?.city}, &nbsp;{" "}
                      {customerState?.label} &nbsp;- &nbsp;{" "}
                      {subsData?.party?.party_addresses?.[0]?.pincode}
                    </Form.Label>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {subsData?.party?.phone_number && (
                  <Form.Group>
                    <Form.Label>{"Phone"} :</Form.Label>
                    &nbsp; {subsData?.party?.phone_number}
                  </Form.Group>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-5">
          <Table className="table table-borderless">
            <thead>
              <tr
                style={{
                  backgroundColor: "#E2E2E2",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                }}
              >
                <th
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  {"ITEMS"}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  {"QTY"}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  {"RATE"}
                </th>
                {subsData?.discount_amount > 0 && (
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    {"DISC"}
                  </th>
                )}
                {subsData?.tax_total > 0 && (
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    {"TAX"}
                  </th>
                )}
                {subsData?.cess_total > 0 && (
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    {"CESS"}
                  </th>
                )}
                <th
                  style={{
                    textAlign: "end",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  {"AMOUNT"}
                </th>
              </tr>
            </thead>
            <tbody>
              {subsData?.donation_voucher_items &&
                subsData?.donation_voucher_items?.length > 0 &&
                subsData?.donation_voucher_items?.map((data, index) => (
                  <tr key={index}>
                    <td
                      className=""
                      style={{
                        fontSize: "13px",
                        fontWeight: 400,
                      }}
                    >
                      {data?.donation_package_name ? (
                        <>
                          {`Package - ${
                            packageName
                              ? packageName
                              : data.donation_package_name
                          }`}
                          <br />
                          {`Code - ${data?.donation_package_code}`}
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className=""
                      style={{
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: 400,
                      }}
                    >
                      {data?.quantity} {data?.unit}
                    </td>
                    <td
                      className=""
                      style={{
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: 400,
                      }}
                    >
                      <GlobalCurrency price={data?.taxable_value} />
                    </td>
                    {subsData?.discount_amount > 0 && (
                      <td
                        className=""
                        style={{
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: 400,
                        }}
                      >
                        <GlobalCurrency price={data?.item_discount_amount} />

                        <span style={{ fontSize: "13px", color: "grey" }}>
                          &nbsp;
                          {data?.item_discount
                            ? `(${data?.item_discount}%)`
                            : "(0%)"}
                        </span>
                      </td>
                    )}
                    {subsData?.tax_total > 0 && (
                      <td
                        className=""
                        style={{
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: 400,
                        }}
                      >
                        <span style={{ marginTop: "0px" }}>
                          <GlobalCurrency price={data?.tax_total} />
                        </span>
                        <span style={{ fontSize: "11px", color: "#6c757d" }}>
                          {data?.tax_rate ? `(${data?.tax_rate}%)` : "(0%) "}
                        </span>
                      </td>
                    )}
                    {subsData?.cess_total > 0 && (
                      <td
                        className=""
                        style={{
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: 400,
                        }}
                      >
                        <span style={{ marginTop: "0px" }}>
                          <GlobalCurrency price={data?.cess} />
                        </span>
                        <span style={{ fontSize: "11px", color: "#6c757d" }}>
                          {data?.tax_rate ? `(${data?.cess_rate}%)` : "(0%) "}
                        </span>
                      </td>
                    )}

                    <td
                      className=""
                      style={{
                        textAlign: "end",
                        fontWeight: 400,
                      }}
                    >
                      <GlobalCurrency price={data?.net_total} />
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr className="bold">
                <td
                  className="border-top-bottom"
                  style={{ fontSize: "13px", fontWeight: 600 }}
                >
                  {"SUB TOTAL"}
                </td>
                <td
                  className="border-top-bottom"
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    textAlign: "center",
                  }}
                >
                  {totalQuantity}
                </td>
                <td
                  className="border-top-bottom"
                  style={{ fontSize: "13px", fontWeight: 600 }}
                ></td>
                {subsData?.discount_amount > 0 && (
                  <td
                    className="border-top-bottom"
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    <GlobalCurrency
                      price={subscriptionTotal?.discount_amount}
                    />
                  </td>
                )}
                {subsData?.tax_total > 0 && (
                  <td
                    className="border-top-bottom"
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    <GlobalCurrency price={subscriptionTotal?.tax_total} />
                  </td>
                )}
                {subsData?.cess_total > 0 && (
                  <td
                    className="border-top-bottom"
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    <GlobalCurrency price={subscriptionTotal?.cess_total} />
                  </td>
                )}

                <td
                  className="border-top-bottom"
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    textAlign: "end",
                  }}
                >
                  <GlobalCurrency price={subscriptionTotal?.grand_total} />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Row>

        <Row classname="">
          <Col lg={6}>
            {bankDetailsCheck && (
              <Col className="mb-3">
                <Form.Label
                  className=""
                  style={{ fontSize: "13px", fontWeight: 600 }}
                >
                  {"BANK DETAILS"}
                </Form.Label>{" "}
                <br />
                {fetchData?.card_holder_name && (
                  <>
                    <Form.Label className="mb-1">
                      {"Name"}:
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {fetchData?.card_holder_name}{" "}
                    </Form.Label>{" "}
                    <br />
                  </>
                )}
                {fetchData?.ifsc_code && (
                  <>
                    <Form.Label className="mb-1">
                      {"IFSC Code"}:
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {fetchData?.ifsc_code}{" "}
                    </Form.Label>{" "}
                    <br />
                  </>
                )}
                {fetchData?.account_number && (
                  <>
                    <Form.Label className="mb-1">
                      {"Account No"}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {fetchData?.account_number}{" "}
                    </Form.Label>{" "}
                    <br />
                  </>
                )}
                {fetchData?.bank || fetchData?.branch_name ? (
                  <>
                    <Form.Label className="mb-1">
                      {"Bank"}:
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {fetchData?.bank}, {fetchData?.branch_name}{" "}
                    </Form.Label>{" "}
                    <br />
                  </>
                ) : (
                  ""
                )}
              </Col>
            )}
            {fetchData?.upi_payment && (
              <Col className={`${bankDetailsCheck ? "" : "mb-3"}`}>
                <Row lg={12}>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: "13px", fontWeight: 600 }}>
                        {"PAYMENT QR CODE"}
                      </Form.Label>
                      <p>
                        {"UPI ID"}: <br /> {fetchData?.upi_payment}{" "}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    {fetchData?.upi_payment &&
                      generateQRCode(fetchData?.upi_payment)}
                  </Col>
                </Row>
              </Col>
            )}
            {subsData?.tnc ||
              (termsAndCondition && (
                <Col
                  className={`${
                    bankDetailsCheck || fetchData?.upi_payment ? "" : ""
                  }`}
                >
                  <Form.Label style={{ fontSize: "13px", fontWeight: 600 }}>
                    {"TERMS AND CONDITIONS"}
                  </Form.Label>
                  <p>{subsData?.tnc ? subsData?.tnc : termsAndCondition} </p>
                </Col>
              ))}
          </Col>
          <Col lg={6} style={{ fontSize: "12px" }}>
            {subsData?.charges &&
              subsData?.charges.length > 0 &&
              subsData?.charges.map((data, index) => (
                <Row className="px-1 " key={index}>
                  <Col lg={7}>{data?.charge_type}</Col>
                  <Col lg={5}>
                    <GlobalCurrency price={data?.charge_value} />
                  </Col>
                </Row>
              ))}
            <Row className="px-0">
              <Col lg={7} className="px-0" style={{ textAlign: "start" }}>
                {"TAXABLE AMOUNT"}
              </Col>
              <Col lg={5} className="p-0" style={{ textAlign: "end" }}>
                <GlobalCurrency
                  price={subsData?.grand_total - subsData?.tax_total}
                />
              </Col>
            </Row>

            {subsData?.donation_voucher_items?.map((data, index) => (
              <React.Fragment key={index}>
                {data?.cgst > 0 && data?.sgst > 0 && (
                  <>
                    <Row className="px-1">
                      <Col
                        lg={7}
                        className="px-0"
                        style={{ textAlign: "start" }}
                      >
                        {"CGST"} @{data?.tax_rate ? data?.tax_rate / 2 : ""}%
                      </Col>
                      <Col lg={5} className="p-0" style={{ textAlign: "end" }}>
                        <GlobalCurrency price={data?.cgst} />
                      </Col>
                    </Row>
                    <Row className="px-1">
                      <Col
                        lg={7}
                        className="px-0"
                        style={{ textAlign: "start" }}
                      >
                        {"SGST"} @{data?.tax_rate ? data?.tax_rate / 2 : ""}%
                      </Col>
                      <Col lg={5} className="p-0" style={{ textAlign: "end" }}>
                        <GlobalCurrency price={data?.sgst} />
                      </Col>
                    </Row>
                  </>
                )}
              </React.Fragment>
            ))}

            {subsData?.donation_voucher_items?.map((taxRow, index) => {
              if (taxRow.cess > 0) {
                return (
                  <Row key={`cess-${index}`} className="px-1">
                    <Col lg={7} className="px-0" style={{ textAlign: "start" }}>
                      {"Cess"} @{taxRow.cess_rate}%
                    </Col>
                    <Col className="p-0" lg={5} style={{ textAlign: "end" }}>
                      <GlobalCurrency price={taxRow.cess} />
                    </Col>
                  </Row>
                );
              }
            })}
            <Row
              className="px-1 py-2 bold"
              style={{
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
              }}
            >
              <Col lg={7} className="px-0" style={{ textAlign: "start" }}>
                {"TOTAL AMOUNT"}{" "}
              </Col>
              <Col
                className="p-0"
                style={{ fontWeight: "bold", textAlign: "end" }}
                lg={5}
              >
                <GlobalCurrency price={subsData?.grand_total} />
              </Col>
            </Row>
            <Row className="px-1 mt-1">
              <Col lg={7} className="px-0" style={{ textAlign: "start" }}>
                {"Recieved Amount"}
              </Col>
              <Col lg={5} className="p-0" style={{ textAlign: "end" }}>
                <GlobalCurrency price={subsData?.paid_amount} />
              </Col>
            </Row>

            <Row>
              <Col
                style={{ textAlign: "start" }}
                lg={12}
                className="px-0 py-1 mt-2"
              >
                <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>
                  {"TOTAL AMOUNT (IN WORDS)"}
                </Form.Label>{" "}
                <br />
                {words ? `${words.toUpperCase()}` : "ZERO RUPEES"}
              </Col>
            </Row>
            <Row className="mt-3">
              {!fetchData?.signature && (
                <Col
                  lg={12}
                  className="border  d-flex justify-content-start"
                  style={{ height: "60px" }}
                ></Col>
              )}
              {fetchData?.signature && (
                <Col lg={12} className="  d-flex justify-content-start">
                  <Image
                    src={fetchData?.signature}
                    alt="signature"
                    style={{ width: "200px", height: "60px" }}
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col
                lg={12}
                className="mt-3 px-0 d-flex flex-column align-items-start"
                height={100}
              >
                <Form.Label
                  className="mb-0"
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                  }}
                >
                  {"Authorized Signatory For"}
                </Form.Label>

                <Form.Label style={{ fontSize: "13px" }}>
                  {selectedBusiness?.business_name}{" "}
                </Form.Label>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DonationSubscriptionAllInvoiceDefault;
